import React from 'react';

import Menu from '@mui/material/Menu';

interface SystemMenuProps {
    trigger: {
        component: React.ReactNode;
        disabled?: boolean;
    }
    content: {
        component: React.ReactElement<any>;
        shouldCloseOnItemClick?: boolean;
    }
}

export const SystemMenu: React.FC<SystemMenuProps> = (props) => {
    const { trigger, content } = props;

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleClickTrigger = (event: React.MouseEvent<HTMLDivElement>) => {
        if (trigger?.disabled) return;
        setAnchorEl(event.currentTarget);
    };

    const handleClickMenuItem = () => {
        if (content.shouldCloseOnItemClick) {
            handleClose();
        }
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <div
                onClickCapture={handleClickTrigger}
            >
                {trigger.component}
            </div>

            <Menu
                open={open}
                onClose={handleClose}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <div
                    onClickCapture={handleClickMenuItem}
                >
                    {content.component}
                </div>
            </Menu>
        </div>
    )
}